import * as React from "react";
import ReactTable from "react-table";
import { Badge, Glyphicon } from "react-bootstrap";
import { obtenerTipoReporte } from "../modelo/TipoReporte";
import { obtenerEstadoPoliza } from "../modelo/EstadoPoliza";
import { DatosEmpresaTraslado } from "../modelo/EmpresasTrasladadas";
import { Link } from "react-router-dom";

export default class TablaEmpresasTrasladadas extends React.Component<TablaEmpresasTrasladadasProps, any> {

    columns = [{
        id: 'tipoDocumento',
        Header: "Tipo Doc",
        accessor: "empresaSAT.tipoDocumentoEmpleador",
        width: 55
    }, {
        id: 'numeroDocumento',
        Header: "Numero Documento",
        accessor: "empresaSAT.numeroDocumentoEmpleador",
        width: 115,
    }, {
        id: 'nitDescentralizado',
        Header: "Nit Desc",
        accessor: "empresaSAT.consecutivoNitDescentralizado",
        width: 55,
    }, {
        id: 'fechaSolicitud',
        Header: "Fecha Solicitud",
        accessor: "empresaSAT.fechaSolicitud",
        width: 105,
    }, {
        id: 'FechaFinAfiliacion',
        Header: "Fin Afiliacion",
        accessor: "empresaSAT.fechaFinAfiliacion",
        width: 105,
    }, {
        id: 'TipoReporte',
        Header: "Tipo Reporte",
        Cell: props => (this.renderTipoReporte(props)),
        width: 95,
    }, {
        id: 'poliza',
        Header: "Poliza",
        accessor: "datosPoliza.poliza",
        width: 95,
    }, {
        id: 'dniEmpleador',
        Header: "Dni",
        accessor: "datosPoliza.dniEmpleador",
        width: 95,
    }, {
        id: 'fechaAlta',
        Header: "Fecha de Alta",
        accessor: "datosPoliza.fechaAlta",
        width: 105,
    }, {
        id: 'fechaBaja',
        Header: "Fecha de Baja",
        accessor: "datosPoliza.fechaBaja",
        width: 105,
    }, {
        id: 'estado',
        Header: "Estado",
        Cell: props => (this.renderEstado(props)),
        width: 135,
    }, {
        id: 'dniEmpleador',
        Header: "Acción",
        accessor: "datosPoliza.dniEmpleador",
        Cell: props => (this.renderAccion(props)),
        width: 50
    }];

    constructor(props: any) {
        super(props);

        this.state = {
            listaEmpresas: [],
            totalEmpresas: 0,
            listaPaginada: [],
            paginaActual: 0,
            registrosPorPagina: 10
        };
    }

    componentDidMount() {
        if (this.state.listaEmpresas.length === 0 || this.state.listaPaginada.length === 0) {
            this.obtenerListaEmpresas();
        }
    }

    obtenerListaEmpresas() {
        const { datosEmpresas } = this.props;

        const numRegistros = Math.min(datosEmpresas.length, this.state.registrosPorPagina);
        const listaPaginadaEmpresas = this.calcularEmpresasPorPagina(datosEmpresas, numRegistros, 1);

        this.setState({
            listaEmpresas: datosEmpresas,
            totalEmpresas: datosEmpresas.length,
            listaPaginada: listaPaginadaEmpresas,
            paginaActual: 0,
            registrosPorPagina: numRegistros
        });
    }

    calcularEmpresasPorPagina(listaEmpresas: Array<DatosEmpresaTraslado>, registrosPorPagina: number, paginaNum: number) {
        return listaEmpresas.slice((paginaNum - 1) * registrosPorPagina, paginaNum * registrosPorPagina);
    }

    renderTipoReporte = (props: any) => {
        const codigoReporte = props.original.empresaSAT.tipoReporte;
        return (obtenerTipoReporte(codigoReporte).descripcion);
    };

    renderEstado = (props: any) => {
        if (props.original.datosPoliza && props.original.datosPoliza.codigoEstado) {
            const codigoEstado = props.original.datosPoliza.codigoEstado;
            const estado = obtenerEstadoPoliza(codigoEstado);
            return (
                <Badge style={{ color: 'black', backgroundColor: estado.color }}>
                    {estado.texto}
                </Badge>
            );
        }
        return false;
    };

    renderAccion = (props: any) => {
        const dni = props.original.datosPoliza.dniEmpleador;
        if (dni) {
            const url = `estructuraEmpresasSAT?dni=${dni}`;
            return (
                <Link to={url}>
                    <span className="icons-table">
                        <Glyphicon glyph={"zoom-in"} />
                    </span>
                </Link>
            );
        } else {
            return false;
        }
    };

    render() {
        const { registrosPorPagina, paginaActual, listaPaginada } = this.state;

        if (listaPaginada.length > 0 && paginaActual >= 0) {
            const totalPaginas = this.calcularTotalPaginas(registrosPorPagina);
            return this.renderContenido(listaPaginada, totalPaginas, registrosPorPagina, paginaActual);
        } else {
            return false;
        }
    }

    renderContenido(listaPaginada: Array<DatosEmpresaTraslado>, paginas: number, tamanoPagina: number, paginaActual: number) {
        let numRegistros = 0;

        if (listaPaginada.length < tamanoPagina) {
            numRegistros = listaPaginada.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{listaPaginada.length}</span> Empresas Trasladadas SAT - Consecutivo {this.props.consecutivoProceso}
                    </h2>
                </div>
                <ReactTable data={listaPaginada}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        this.actualizarPagina(pageIndex, (pageSize ? pageSize : tamanoPagina));
    }

    actualizarPagina(pageIndex: number, registrosPorPagina: number) {
        const listaPaginadaEmpresas = this.calcularEmpresasPorPagina(this.state.listaEmpresas, registrosPorPagina, pageIndex + 1);
        this.setState({
            listaPaginada: listaPaginadaEmpresas,
            registrosPorPagina: registrosPorPagina,
            paginaActual: pageIndex
        });
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    calcularTotalPaginas(registrosPorPagina: number) {
        const dividirRegistros = this.state.totalEmpresas / registrosPorPagina;
        return Math.ceil(dividirRegistros);
    }
}

interface TablaEmpresasTrasladadasProps {
    consecutivoProceso: number,
    datosEmpresas: Array<DatosEmpresaTraslado>
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/empresas_trasladadas/componentes/TablaEmpresasTrasladadas.tsx